import { gsap } from 'gsap';

const createAccordeon = (parent) => {

	const accordeonArray = parent.querySelectorAll('[data-accordeon-element]');
	if (accordeonArray.length === 0) return;

	const needCloseOther = parent.dataset.needCloseOther;
	const duration = +parent.dataset.duration || 0.3;
	const ease = parent.dataset.ease || 'power1.out';
	const delay = +parent.dataset.delay || 0;
	const onOpenComplete = (item) => {
		window.scrollTo({top: item.offsetTop - 50, behavior: 'smooth'});
	};

	accordeonArray.forEach(element => {
		const button = element.querySelector('[data-accordeon-button]');
		const content = element.querySelector('[data-accordeon-content]');

		if (!element.classList.contains('is-open')) {
			gsap.set(content, {
				height: 0
			});
		}

		button.addEventListener('click', () => {
			element.classList.contains('is-open') ? close(element, content) : open(element, content);
		});
	});

	function open(element, content) {
		gsap.to(content, {
			height: 'auto',
			duration: duration,
			ease: ease,
			delay: delay,
			onStart: () => {
				element.classList.add('is-open');
				if (needCloseOther) closeOther(element);
			},
			onComplete: () => onOpenComplete(element)
		});
	}

	function close(element, content) {
		gsap.to(content, {
			height: 0,
			duration: duration,
			ease: ease,
			delay: delay,
			onStart: () => {
				element.classList.remove('is-open');
			}
		});
	}

	function closeOther(current) {
		parent.querySelectorAll('[data-accordeon-element]').forEach(element => {
			const content = element.querySelector('[data-accordeon-content]');
			element !== current ? close(element, content) : false;
		});
	}
};

export const initAccordeons = () => {
	const group = document.querySelectorAll('[data-accordeon-wrapper]');
	if (group.length === 0) return;

	group.forEach(createAccordeon);
};
